module.exports = {
	apiUrl: '/api',
	baseURL: '/',
	landingAssetsURL: '/kidsbox/'
}
